import { z } from 'zod';

export const permissionItemSchema = z.object({
  id: z.coerce.number(),
  code: z.string(),
  module: z.string(),
  description: z.string(),
  isActive: z.boolean(),
  heldByRoleCount: z.coerce.number(),
});

export const permissionItemListSchema = z.array(permissionItemSchema);

export type PermissionItem = z.infer<typeof permissionItemSchema>;

export const userRoleItemSchema = z.object({
  id: z.coerce.number(),
  code: z.string(),
  name: z.string(),
  isActive: z.boolean(),
});

export const userRoleItemListSchema = z.array(userRoleItemSchema);

export type UserRoleItem = z.infer<typeof userRoleItemSchema>;

export const effectivePermissionSchema = z.object({
  code: z.string(),
  module: z.string(),
  description: z.string(),
  viaRoleCode: z.string().nullable(),
});

export const effectivePermissionListSchema = z.array(effectivePermissionSchema);

export type EffectivePermission = z.infer<typeof effectivePermissionSchema>;

export const grantChangeSchema = z.object({
  added: z.array(z.string()),
  removed: z.array(z.string()),
});

export type GrantChange = z.infer<typeof grantChangeSchema>;

export interface ModuleGroup<TItem> {
  module: string;
  permissions: TItem[];
}

export function groupByModule<TItem extends { module: string }>(
  items: TItem[],
): ModuleGroup<TItem>[] {
  const byModule = new Map<string, TItem[]>();

  for (const item of items) {
    const existing = byModule.get(item.module);
    if (existing) existing.push(item);
    else byModule.set(item.module, [item]);
  }

  return [...byModule].map(([module, grouped]) => ({ module, permissions: grouped }));
}
